import { FunctionComponent, useMemo } from 'react';
import { FieldType } from '@/api/dtos';
import { faInputText } from '@fortawesome/pro-duotone-svg-icons';
import { ConfigurationType, IConfigurationField, LinkedProperties } from '@/utilities/forms/ConfigurationFormProcessor';
import ConfigurationItem, { IConfigurationExpandProps } from './ConfigurationItem';

const ConfigurationFormField: FunctionComponent<IConfigurationField & IConfigurationExpandProps> = ({ setExpanded, toggleExpand, expanded, ...item}) => {
    const {
        trialConfiguration,
        formFieldPropertyPath,
        formFieldMetadata,
        formSectionKey,
        isGlobalConfiguration,
        isTrialConfiguration,
        values
    } = item;

    const fieldTypeLabel =  useMemo(() => {
        switch (formFieldMetadata?.fieldType) {
            case FieldType.Checkbox:
                return 'Checkbox';
            case FieldType.Ctcae:
                return 'CTCAE';
            case FieldType.Date:
                return 'Date';
            case FieldType.File:
                return 'File';
            case FieldType.MultiSelect:
                return 'MultiSelect';
            case FieldType.MultilineText:
                return 'MultilineText';
            case FieldType.Numeric:
                return 'Numeric';
            case FieldType.Radio:
                return 'Radio';
            case FieldType.Select:
                return 'Select';
            case FieldType.Text:
                return 'Text';
            default:
                return 'Unknown';
        }
    }, [formFieldMetadata?.fieldType])

    return (
        <ConfigurationItem
            toggleExpand={toggleExpand}
            setExpanded={setExpanded}
            expanded={expanded}
            spacing={
                isGlobalConfiguration ? 
                    formSectionKey ?
                        24 : 16 : 
                    formSectionKey ?
                        32 : 24
            }
            basePropertyPath={formFieldPropertyPath!}
            edit
            expandable={!!values && values.length > 0}
            enableable={!isTrialConfiguration && !isGlobalConfiguration}
            linkable={!isTrialConfiguration}
            linkedProperties={LinkedProperties[ConfigurationType.Field]}
            title={formFieldMetadata?.name ?? 'Unknown Field'}
            description={fieldTypeLabel}
            type="Field"
            typeIcon={faInputText}
            item={item}
        />
    );
}

export default ConfigurationFormField;